let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bnLlX")).then(() => parcelRequire('jLluB'));